export const applicationStateRender = (e) => {
    const state = e.data.state;
    const portfolio = e.data.isPortfolio;

    if (portfolio) {
        return '';
    }

    return state;
};
